﻿import { GMetrixButton } from 'components/GMetrixButton/GMetrixButton';
import { FormattedMessage, useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import { PageTitle } from 'utils/pageTitle';

export const Error404 = () => {

    const { formatMessage } = useIntl();

    const navigate = useNavigate();

    return (
        <div className={'error-404 d-flex h-100 align-items-center justify-content-center'}>
            <div className="text-center">
                <PageTitle title={formatMessage({ id: 'page_not_found_or_gmetrix.495316e6', defaultMessage: 'Page Not Found | GMetrix' })} />
                <h1>
                    <FormattedMessage defaultMessage="404 Not Found" id="404_not_found.7cfdd904" />
                </h1>
                <GMetrixButton className="mt-3" onClick={() => navigate('/')} variant="primary">
                    <FormattedMessage defaultMessage="Return Home" id="return_home.ce8025ec" />
                </GMetrixButton>
            </div>
        </div>
    );

};